import type { MouseEvent, ReactNode } from 'react'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import TaActionButton from '../TaActionButton'
import { ICON_MD } from '../../common/theme'

interface BatchImproveButtonProps {
  count: number
  selectedCount?: number
  onClick: () => void
  disabled?: boolean
  icon?: ReactNode
  iconSize?: number
  sx?: any
  testId?: string
}

// Batch sibling of SuggestImprovementsButton — same TaActionButton
// look (lightbulb icon) but fires a multi-question pmbatchprocess via
// the supplied onClick. Used by BidScoreTab's header so the
// batch-improvements action reads as the same affordance the user
// already knows from per-question rows.
export default function BatchImproveButton({
  count, selectedCount = 0, onClick, disabled, icon, iconSize, sx, testId,
}: BatchImproveButtonProps) {
  const title = selectedCount > 0
    ? `Suggest Improvements (${selectedCount} selected)`
    : count > 0 ? 'Suggest Improvements (all)' : 'Suggest Improvements'
  const handleClick = (e?: MouseEvent) => {
    e?.stopPropagation()
    onClick()
  }
  return (
    <TaActionButton
      title={title}
      onClick={handleClick}
      disabled={disabled || count === 0}
      icon={icon ?? <LightbulbOutlinedIcon sx={{ fontSize: ICON_MD }} />}
      iconSize={iconSize}
      sx={sx}
      testId={testId}
    />
  )
}
